<script setup>
import { provide, reactive } from "vue";

const props = defineProps({
  activeIndex: {
    type: Number,
    required: false,
    default: null
  },
  expanded: {
    type: Boolean,
    required: false,
    default: false
  }
});

const Accordion = reactive({
  count: 0,
  active: props.activeIndex,
  expanded: props.expanded
});

provide("Accordion", Accordion);
</script>

<template>
  <ul class="accordion">
    <slot />
  </ul>
</template>
